<template>
  <div class="offlineOrderDetail">
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      fixed
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="offlineOrderDetail_content">
      <div class="offlineOrderDetail_content_bot">
        <p class="offlineOrderDetail_content_bot_top">
          <span class="span1">订单信息</span>
          <!-- 只有refundOrderStatus退款状态为1：待审核的时候才显示下面退款中标签 -->
          <span
            class="span2"
            v-if="orderDetail.refundOrderStatus == '1'"
            style="color: #ee3721"
            >退款中...</span
          >
          <span
            class="span2"
            v-if="orderDetail.refundOrderStatus == '5'"
            style="color: #666666"
            >退款完成</span
          >
          <!-- 后台拒绝退款之后，页面右上角标签显示已购买 -->
          <span
            class="span2"
            v-if="orderDetail.refundOrderStatus == '2'"
            style="color: #666666"
            >已购买</span
          >
        </p>
        <div class="offlineOrderDetail_content_bot_cen">
          <img
            :src="orderDetail.coverMaterialUrl"
            class="offlineOrderDetail_content_bot_cen_img"
          />
          <div class="offlineOrderDetail_content_bot_cen_rig">
            <div class="offlineOrderDetail_content_bot_cen_rig_title">
              {{ orderDetail.productName }}
            </div>
            <!-- <div
              class="offlineOrderDetail_content_bot_cen_rig_biaoqian"
              v-if="orderDetail.labels && orderDetail.labels.length > 0"
            >
              {{ orderDetail.labels[0].label }}
            </div> -->
            <div class="offlineOrderDetail_address">
              <img
                src="@/assets/images/setting/place.png"
                v-if="orderDetail.holdAddress"
              />
              <span>{{ orderDetail.holdAddress }}</span>
            </div>
          </div>
        </div>
        <div
          class="offlineOrderDetail_content_bot_pay"
          v-if="title == '已购买'"
        >
          <p>支付方式：</p>
          <div class="offlineOrderDetail_content_bot_pay_way">
            <img :src="payPic" />
            <p>{{ orderDetail.payTypeName == "微信" ? "微信" : "支付宝" }}</p>
          </div>
        </div>
        <div class="offlineOrderDetail_content_bot_pay">
          <p>实际付款：</p>
          <div class="offlineOrderDetail_content_bot_pay_money">
            <span>¥</span
            >{{
              orderDetail.originalPrice &&
              orderDetail.originalPrice.toString().indexOf(".") > -1
                ? orderDetail.originalPrice.toString().split(".")[0]
                : orderDetail.originalPrice
            }}<span
              v-if="
                orderDetail.originalPrice &&
                orderDetail.originalPrice.toString().indexOf('.') > -1 &&
                orderDetail.originalPrice.toString().split('.')[1]
              "
              >.{{ orderDetail.originalPrice.toString().split(".")[1] }}</span
            >
          </div>
        </div>
      </div>
      <div class="offlineOrderDetail_content_bot">
        <div class="offlineOrderDetail_content_bot_pay">
          <p>姓名：</p>
          <div class="offlineOrderDetail_content_bot_pay_way">
            <p>{{ orderDetail.attendUserName }}</p>
          </div>
        </div>
        <div class="offlineOrderDetail_content_bot_pay">
          <p>手机号：</p>
          <div class="offlineOrderDetail_content_bot_pay_way">
            <p>{{ orderDetail.attendUserTel }}</p>
          </div>
        </div>
        <div class="offlineOrderDetail_content_bot_pay">
          <p>开课时间：</p>
          <div class="offlineOrderDetail_content_bot_pay_way">
            <p>{{ orderDetail.courseStartTime }}</p>
          </div>
        </div>
        <div class="offlineOrderDetail_content_bot_pay">
          <p>身份类型：</p>
          <div class="offlineOrderDetail_content_bot_pay_way">
            <p>{{ orderDetail.identityTypeName }}</p>
          </div>
        </div>
        <div class="offlineOrderDetail_content_bot_pay">
          <p>职业：</p>
          <div class="offlineOrderDetail_content_bot_pay_way">
            <p>{{ orderDetail.career }}</p>
          </div>
        </div>
        <div class="offlineOrderDetail_content_bot_pay">
          <p>报名单位：</p>
          <div class="offlineOrderDetail_content_bot_pay_way">
            <p>{{ orderDetail.registrationUnit }}</p>
          </div>
        </div>
      </div>
      <div class="offlineOrderDetail_content_order">
        <div class="offlineOrderDetail_content_order_num">
          <p>订单编号：</p>
          <p class="offlineOrderDetail_content_order_num_right">
            {{ orderDetail.id }}
          </p>
          <div
            :data-clipboard-text="orderDetail.id"
            class="offlineOrderDetail_content_order_num_copy"
          >
            复制
          </div>
        </div>
        <div class="offlineOrderDetail_content_order_time">
          <p>
            下单时间：<span>{{ orderDetail.createTime }}</span>
          </p>
        </div>
        <div
          class="offlineOrderDetail_content_order_time"
          v-if="title == '已购买'"
        >
          <p>
            支付时间：<span>{{ orderDetail.payTime }}</span>
          </p>
        </div>
        <div
          class="offlineOrderDetail_content_order_time"
          v-if="orderDetail.refundOrderStatus == '5'"
        >
          <p>
            退款时间：<span>{{ orderDetail.refundFinishTime }}</span>
          </p>
        </div>
      </div>
      <div class="offlineOrderDetail_content_description">
        <p>下单说明：</p>
        <p>1.开课后不允许申请退款</p>
        <p>2.开课后不支持申请延期上课</p>
        <p>3.发票统一开课后进行开具</p>
        <p>4.退款将在1-15个工作日退回支付渠道</p>
      </div>
      <div class="offlineOrderDetail_content_fix">
        <!-- 按钮显示情况
        正常购买之后：订单页按钮显示联系我们 申请退款 申请延期
        申请退款后：
        退款中refundOrderStatus=1显示联系我们 撤销退款
        退款成功refundOrderStatus=5显示联系我们
        拒绝退款refundOrderStatus=2显示联系我们 退款已拒绝 申请延期 -->
        <div class="offlineOrderDetail_content_fix_leftBt" @click="contact">
          联系我们
        </div>
        <div
          class="offlineOrderDetail_content_fix_leftBt"
          @click="refund"
          v-if="showRefundBtn && orderDetail.orderState != '2'"
        >
          申请退款
        </div>
        <div
          class="offlineOrderDetail_content_fix_leftBt"
          @click="refuseRefund"
          v-if="
            orderDetail.refundOrderStatus == '2' &&
            orderDetail.orderState != '2'
          "
        >
          退款已拒绝
        </div>
        <div
          class="offlineOrderDetail_content_fix_rightBt"
          @click="delay"
          v-if="
            orderDetail.refundOrderStatus != '1' &&
            orderDetail.refundOrderStatus != '5' &&
            orderDetail.orderState != '2'
          "
        >
          申请延期
        </div>
        <div
          class="offlineOrderDetail_content_fix_rightBt"
          @click="cancelRefund"
          v-if="
            orderDetail.refundOrderStatus == '1' &&
            orderDetail.orderState != '2'
          "
        >
          撤销退款
        </div>
      </div>
    </div>
    <contact-us
      :contactShow="contactShow"
      @close="handleClose"
      :imgList="imgList"
      :phone="phone"
    ></contact-us>
    <refund-apply
      :popShow="popShow"
      @submitRefundMsg="submitRefundMsg"
      @close="popShow = false"
    ></refund-apply>
    <course-Time-dialog
      :time="orderDetail.courseStartTime"
      :options="orderDetail.addresses"
      v-if="timeShow"
      @closeTimeShow="timeShow = false"
      @setTime="setTime"
    ></course-Time-dialog>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { decryptBy, encryptBy } from "@/assets/js/encryption";
import {
  _orderDetail,
  _applyRefund,
  _cancelApplyRefund,
  _modifyCourseOrder,
} from "../../api/setting";
import ContactUs from "./components/contact-us.vue";
import RefundApply from "./components/refund-apply.vue";
import courseTimeDialog from "./courseTimeDialog.vue";
import dayjs from "dayjs";
import { Dialog } from "vant";
export default {
  name: "offlineOrderDetail",
  data() {
    return {
      timeShow: false,
      contactShow: false,
      title: "", //页面title
      orderDetail: {}, //订单详情
      imgName: "", //订单状态图片
      payPic: "", //支付方式图片
      id: "", //订单id
      popShow: false, //支付弹窗标识
      radio: "0", //支付方式选择标识
      payTypeList: [], //支付方式列表
      imgList: [
        // { img: require("@/assets/images/setting/wx.jpg"), name: "崔老师" },
        // { img: require("@/assets/images/setting/wx.jpg"), name: "陈老师" },
      ],
      phone: "",
      nowDate: dayjs().format("YYYY-MM-DD"),
      courseStartTime: "",
      courseEndTime: "",
    };
  },
  components: {
    ContactUs,
    RefundApply,
    courseTimeDialog,
  },
  created() {
    this.id = this.$route.query.id;
    this.getOrderDetail();
    // this.orderDetail = JSON.parse(localStorage.getItem('orderDetail'));
  },
  filters: {},
  computed: {
    // 当前日期跟开课时间段的开始开课时间比较，判断申请退款按钮及申请改期按钮显示状态
    canedit: function () {
      return dayjs(this.courseStartTime).isAfter(dayjs(this.nowDate));
    },
    showRefundBtn() {
      let show = false;
      if (["", null, 4].some((v) => this.orderDetail.refundOrderStatus == v)) {
        show = true;
      }
      return show;
    },
  },
  mounted() {
    console.log(this.nowDate);
    let clipborad = new Clipboard(".offlineOrderDetail_content_order_num_copy");
    clipborad.on("success", (e) => {
      this.$toast("复制成功");
    });
  },
  methods: {
    handleClose() {
      this.contactShow = false;
    },
    // 返回
    onClickLeft() {
      if (this.$router.app._route.query.sourceType) {
        this.$router.push("myOrder");
        this.$router.push({
          path: "/myOrder",
          query: { sourceType: 1 },
        });
      } else {
        this.$router.go(-1);
      }
    },
    phoneType(val) {
      if (val) {
        if (val.length === 11) {
          return val;
        } else {
          return decryptBy(val);
        }
      }
    },
    //跳转到添加地址
    goAdress() {
      this.$router.push({
        path: "/addAdress",
      });
    },
    // 联系我们弹框
    contact() {
      this.contactShow = true;
    },
    //申请退款弹框
    refund() {
      console.log("111", this.popShow);
      // 若课程已过开课时间，按钮点击提示：课程已开课，暂不支持申请退款，如有疑问请联系我们
      if (this.canedit) {
        this.popShow = true;
      } else {
        Dialog.alert({
          message: "课程已开课，暂不支持申请退款，如有疑问请联系我们",
          theme: "round-button",
          confirmButtonColor: "#24BFFB",
        }).then(() => {
          this.popShow = false;
        });
      }
    },
    //申请延期
    delay() {
      // 若课程已过开课时间，按钮点击提示：课程已开课，暂不支持延期上课，如有疑问请联系我们
      if (this.canedit) {
        this.timeShow = true;
      } else {
        Dialog.alert({
          message: "课程已开课，暂不支持延期上课，如有疑问请联系我们",
          theme: "round-button",
          confirmButtonColor: "#24BFFB",
        }).then(() => {
          this.timeShow = false;
        });
      }
    },
    //撤销退款
    cancelRefund() {
      _cancelApplyRefund({
        createUser: "",
        id: this.id,
        operateContent: "",
      }).then((res) => {
        if (res.code == 200) {
          this.getOrderDetail();
        } else {
          this.$toast(res.message);
        }
      });
    },
    //   提交退款申请
    submitRefundMsg(msg) {
      console.log("msg", msg);
      _applyRefund({
        createUser: "",
        id: this.id,
        operateContent: msg,
      }).then((res) => {
        if (res.code == 200) {
          this.getOrderDetail();
          this.popShow = false;
        } else {
          this.$toast(res.message);
        }
      });
    },
    //退款拒绝之后点击按钮弹框
    refuseRefund() {
      Dialog.alert({
        title: "拒绝原因",
        message: this.orderDetail.refundAuditeReason || "拒绝退款",
        theme: "round-button",
        confirmButtonColor: "#24BFFB",
      }).then(() => {
        // on close
      });
    },
    setTime(val, index) {
      console.log(val, "val");
      let s = val.split("~")[0];
      let e = val.split("~")[1];
      if (val != "") {
        if (
          dayjs(s).isSame(dayjs(this.courseStartTime)) &&
          dayjs(e).isSame(dayjs(this.courseEndTime))
        ) {
          Dialog.alert({
            message: "您已报名该时间段课程",
            theme: "round-button",
            confirmButtonColor: "#24BFFB",
          }).then(() => {});
        } else {
          this.orderDetail.courseStartTime = val;
          this.orderDetail.holdAddress =
            this.orderDetail.addresses[index].holdAddress;
          //调修改课程开始时间接口
          _modifyCourseOrder({
            id: this.id,
            courseStartTime: this.orderDetail.courseStartTime,
            holdAddress: this.orderDetail.holdAddress,

            attendUserId: this.orderDetail.attendUserId,
            attendUserName: this.orderDetail.attendUserName,
            attendUserTel: this.orderDetail.attendUserTel,
            career: this.orderDetail.career,
            identityTypeId: this.orderDetail.identityTypeId,
            identityTypeName: this.orderDetail.identityTypeName,
            postAddress: this.orderDetail.postAddress,
            postAddressId: this.orderDetail.postAddressId,
            recipientName: this.orderDetail.recipientName,
            recipientTel: this.orderDetail.recipientTel,
            registrationUnit: this.orderDetail.registrationUnit,
          }).then((res) => {
            if (res.code == 200) {
              this.getOrderDetail();
            } else {
              this.$toast(res.message);
            }
          });
        }
      }
    },
    //修改地址
    modify() {
      this.$router.push({
        path: "/adressList",
        query: {
          orderId: this.orderDetail.id,
          postAddressId: this.orderDetail.postAddressId,
        },
      });
    },
    // 获取订单详情
    getOrderDetail() {
      _orderDetail({
        orderId: this.id,
        // orderId: "1750078732112384002",
      }).then((res) => {
        if (res && res.code == 200) {
          this.orderDetail = res.data;
          this.courseStartTime = this.orderDetail.courseStartTime
            .split("~")[0]
            .trim();
          this.courseEndTime = this.orderDetail.courseStartTime
            .split("~")[1]
            .trim();

          this.title =
            this.orderDetail.orderState == 0
              ? "待付款"
              : this.orderDetail.orderState == 1
              ? "已购买"
              : this.orderDetail.orderState == 2
              ? "已取消"
              : this.orderDetail.orderState == 3
              ? "已退款"
              : "订单详情";
          this.payPic =
            this.orderDetail.payTypeName == "微信"
              ? require("@/assets/images/setting/wei.png")
              : require("@/assets/images/setting/zhi.png");

          this.imgList = this.orderDetail.webChatUrl.split(",");
          console.log(this.imgList, "this.imgList");
          this.phone = this.orderDetail.customerServiceTel;
        } else {
          this.$toast(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.offlineOrderDetail {
  height: 100%;
  background: #f5f7fa;
  position: relative;
  .offlineOrderDetail_content {
    padding-top: 48px;
    .offlineOrderDetail_content_description {
      font-size: 12px;
      color: #626a6b;
      padding: 8px 20px;
      height: 180px;
      width: 100%;
      background: #f5f7fa;
    }
  }
  .offlineOrderDetail_content_noAddress {
    width: 375px;
    background: #ffffff;
    .offlineOrderDetail_content_noAddress_cont {
      display: flex;
      justify-content: space-between;
      padding: 38px 0;
      .offlineOrderDetail_content_noAddress_cont_left {
        display: flex;
        align-items: center;
        img {
          width: 22px;
          height: 22px;
          margin-right: 10px;
          margin-left: 20px;
        }
        div {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #949c9d;
        }
      }
      .offlineOrderDetail_content_noAddress_cont_right {
        width: 22px;
        height: 22px;
        margin-right: 30px;
      }
    }
    .offlineOrderDetail_content_address_bottom {
      display: block;
      width: 100%;
    }
  }
  .offlineOrderDetail_content_bot {
    padding: 12px 21px 15px 21px;
    width: 345px;
    background: #ffffff;
    border-radius: 4px;
    margin: 8px 0;
    margin-left: 15px;
    .offlineOrderDetail_content_bot_top {
      font-family: PingFangSC-Medium, PingFang SC;
      color: #2e4344;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .span1 {
        font-size: 16px;
        font-weight: 500;
      }
      .span2 {
        font-size: 14px;
      }
    }
    .offlineOrderDetail_content_bot_cen {
      display: flex;
      .offlineOrderDetail_content_bot_cen_img {
        width: 128px;
        height: 72px;
        border-radius: 4px;
        margin-right: 12px;
      }
      .offlineOrderDetail_content_bot_cen_rig {
        .offlineOrderDetail_content_bot_cen_rig_title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2e4344;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          margin-top: 4px;
          margin-bottom: 8px;
        }
        .offlineOrderDetail_address {
          color: #ee3721;
          font-size: 14px;
          display: flex;
          justify-content: start;
          align-items: center;
          img {
            width: 18px;
            height: 18px;
          }
          span {
            margin-left: 5px;
          }
        }
        .offlineOrderDetail_content_bot_cen_rig_biaoqian {
          display: inline-block;
          height: 22px;
          background: rgba(250, 125, 0, 0.1);
          border-radius: 11px;
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fa7d00;
          line-height: 22px;
          text-align: center;
          padding: 0 8px;
          margin-top: 4px;
        }
      }
    }
    .offlineOrderDetail_content_bot_pay {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 14px;
      p {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #141414;
      }
      .offlineOrderDetail_content_bot_pay_way {
        display: flex;
        align-items: center;
        img {
          width: 22px;
          margin-right: 4px;
        }
        p {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2e4344;
        }
      }
      .offlineOrderDetail_content_bot_pay_money {
        font-size: 20px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #2e4344;
        span {
          font-size: 14px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #2e4344;
        }
      }
    }
  }
  .offlineOrderDetail_content_order {
    padding: 12px 21px 15px 21px;
    width: 345px;
    background: #ffffff;
    border-radius: 4px;
    margin: 8px 0;
    margin-left: 15px;
    .offlineOrderDetail_content_order_num {
      display: flex;
      justify-content: space-between;
      p {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .offlineOrderDetail_content_order_num_right {
        width: 195px;
        overflow: hidden; //超出隐藏
        white-space: nowrap; //不折行
        text-overflow: ellipsis; //溢出显示省略号
        color: #2e4344;
        text-align: left;
      }
      div {
        width: 40px;
        height: 20px;
        background: #f5f7fa;
        border-radius: 3px;
        text-align: center;
        line-height: 20px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2e4344;
      }
    }
    .offlineOrderDetail_content_order_time {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-top: 12px;
    }
  }

  .offlineOrderDetail_content_fix {
    position: fixed;
    bottom: 0;
    width: 375px;
    height: 60px;
    background: #ffffff;
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
    .offlineOrderDetail_content_fix_leftBt {
      width: 90px;
      height: 40px;
      background: #f3f6f7;
      border-radius: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #626a6b;
      text-align: center;
      line-height: 40px;
      margin: 10px 10px 0 5px;
    }
    .offlineOrderDetail_content_fix_rightBt {
      width: 90px;
      height: 40px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 20px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin-left: 5px;
      margin-top: 10px;
    }
  }
  .popBox_price {
    font-size: 32px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #ee3721;
    text-align: center;
    margin-top: 19px;
    span {
      font-size: 24px;
    }
  }
  .popBox_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #484848;
    margin-top: 20px;
    margin-left: 20px;
  }
  .popBox_payStyle_wei {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    .popBox_payStyle_wei_left {
      display: flex;
      align-items: center;
      img {
        width: 44px;
        height: 44px;
        margin-left: 30px;
        margin-right: 12px;
      }
      p {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #484848;
      }
    }
    .popBox_payStyle_wei_right {
      margin-right: 40px;
    }
  }
  .popBox_button {
    width: 300px;
    height: 44px;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
    border-radius: 22px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-left: 37.5px;
    margin-top: 56px;
  }
}
</style>
